import { apiService } from './apiService';

export const userService = {
  // Get all users
  async getUsers(params?: { role?: string; status?: string; departmentId?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.role) queryParams.append('role', params.role);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.departmentId) queryParams.append('departmentId', params.departmentId);
    
    const query = queryParams.toString();
    return await apiService.get(`/users${query ? `?${query}` : ''}`);
  },

  // Get user by ID
  async getUser(id: string | number) {
    return await apiService.get(`/users/${id}`);
  },

  // Create user
  async createUser(data: any) {
    return await apiService.post('/users', data);
  },

  // Update user
  async updateUser(id: string | number, data: any) {
    return await apiService.put(`/users/${id}`, data);
  },

  async changePassword(id: string | number, data: { currentPassword: string; newPassword: string }) {
    return await apiService.put(`/users/${id}/change-password`, data);
  },

  // Delete user
  async deleteUser(id: string | number) {
    return await apiService.delete(`/users/${id}`);
  },

  // Reset password & send via SMS for selected users
  async resetPasswordSendSms(userIds: (string | number)[]) {
    return await apiService.post('/users/reset-password-sms', { userIds });
  },

  // Reset daily SMS/login limit for a phone number
  async resetSmsLimitByPhone(phone: string) {
    return await apiService.post('/users/reset-sms-limit', { phone });
  },

  // Terminate all sessions
  async terminateAllSessions() {
    return await apiService.post('/users/terminate-sessions');
  },

  // Get departments
  async getDepartments() {
    return await apiService.get('/departments');
  },

  async createDepartment(data: any) {
    return await apiService.post('/departments', data);
  },

  async updateDepartment(id: string | number, data: any) {
    return await apiService.put(`/departments/${id}`, data);
  },

  async deleteDepartment(id: string | number) {
    return await apiService.delete(`/departments/${id}`);
  },

  // Get roles
  async getRoles() {
    return await apiService.get('/roles');
  },

  // Get role by ID
  async getRole(id: string | number) {
    return await apiService.get(`/roles/${id}`);
  },

  // Create role
  async createRole(data: any) {
    return await apiService.post('/roles', data);
  },

  // Update role
  async updateRole(id: string | number, data: any) {
    return await apiService.put(`/roles/${id}`, data);
  },

  // Delete role
  async deleteRole(id: string | number) {
    return await apiService.delete(`/roles/${id}`);
  },
};
